import { render, staticRenderFns } from "./InquiryConfirm.vue?vue&type=template&id=b7ed434c&"
import script from "./InquiryConfirm.vue?vue&type=script&lang=ts&"
export * from "./InquiryConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports